import React, { useState, useEffect, useRef } from 'react';
// import { InfoCircleOutlined } from '@ant-design/icons';
// import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Scrollbars } from 'react-custom-scrollbars';
import { Modal, Form, Row, Col, message, Popover } from 'antd'; // Select,Checkbox
import PropTypes from 'prop-types';
import ConfirmationPopup from './ConfirmationPopup'
import AllCancelPopup from './AllCancelPopup';
import { AddUser } from '../style';
import { FetchAllGroup } from '../../../Api/Services/UserGroupApiService';
import { getAllUsersData } from '../../../Api/Services/CommonApiService'
import { getAllSharedReportUserPermission, getShareById, createSharing, updateSharing, deleteSharing } from '../../../Api/Services/SharingApiService'
import { BasicFormWrapper, TopToolBoxClone3 } from '../../styled';
import { AutoComplete } from '../../../components/autoComplete/autoComplete';
import { AtbdTopDropdwon } from '../../../components/utilities/auth-info/auth-info-style';
import { Button } from '../../../components/buttons/buttons';
import { AutoCompletes } from '../TypeAhead/Typeahead';
import { ShareIcon } from '../../../components/Icons/Icons';

// const { item } = Select;

const Popup = ({ sharePopup, setSharePopup, sharingType, sharingIds, PageTypes, setStates }) => {
    const maxVisibleImages = 5;
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [users, setUsers] = useState([])
    const [sendTo, setSendTo] = useState()
    const [exportData, setExportData] = useState([])
    const [FilterData, setFilterData] = useState([])
    const [accessData, setAccessData] = useState()
    const [shareUser, setShareUser] = useState()
    const [permission, setPermission] = useState()
    const [allusergroupList, setAllusergroupList] = useState([])
    const [confirmPopup, setConfirmPopup] = useState(false)
    // const [previousPermission, setPreviousPermission] = useState()
    const [deleteId, setDeleteId] = useState()
    const [open, setOpen] = useState(false);
    const [access, setAccess] = useState("Read")
    const [pageType, setPageType] = useState("Create")
    const localData = useSelector((state) => state.localRedux);
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const ProfileData = localData.profile
    const profile = ProfileData
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter((item) => item.userId !== profile.userId)
            setUsers(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function GetSharedDetails() {
        try {
            const data = await getAllSharedReportUserPermission(profile.userId, sharingType, sharingIds.join(','))
            setExportData(data);
            setFilterData(data);
        } catch (error) {
            message.error(error)
        }
    }
    const AccessDetails = async (id) => {
        try {
            const data = await getShareById(id)
            setAccessData(data)
            // setPreviousPermission(data.sharePermission)
            setPermission(data.sharePermission)
        } catch (error) {
            message.error(error)
        }
    }
    async function delteAllsharing(value) {
        await Promise.all(
            value.map(async (item) => {
                try {
                    await deleteSharing(item.sharingId)
                } catch (error) {
                    message.error(error)
                }
            })
        );
        GetSharedDetails()
    }
    async function deleteMenu(id) {
        try {
            const Response = await deleteSharing(id)
            if (Response.status === 200) {
                const data = await getAllSharedReportUserPermission(shareUser, sharingType, sharingIds.join(','))
                delteAllsharing(data)
                setConfirmPopup(false)
                setPermission()
                message.success("Record sharing has been revoked successful")
                setPageType("Create");
                if (PageTypes === "Multiple") {
                    setStates({
                        selectedRows: [],
                        selectedRowKeys: [],
                    })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setSharePopup(false);
        if (PageTypes === "Multiple") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
    }
    const handleClose = () => {
        if (((pageType === "Update" && permission !== accessData?.sharePermission) || (pageType === "Create" && sendTo?.length))) {
            setCancelConfirmOpen(true)
        }
        else {
            setSharePopup(false);
            if (PageTypes === "Multiple") {
                setStates({
                    selectedRows: [],
                    selectedRowKeys: [],
                })
            }
        }
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return "";
        return trimmed ?? value;
    };
    const handleSearch = (searchText) => {
        const searchValue = normalizeValue(searchText)
        const filteredData = FilterData.filter(item => {
            const searchableFields = [
                normalizeValue(item.shareWithFirstName),
                normalizeValue(item.shareWithLastName),
                normalizeValue(item.shareWithUserGroup),
            ];
            return searchableFields.some(field =>
                field && field.toString().toUpperCase().includes(searchValue.toUpperCase())
            );
        });
        setExportData(filteredData)
    };
    async function GetUsergroupList() {
        try {
            const response = await FetchAllGroup()
            const withUserCounts = response.data.map(group => ({
                ...group,
                groupUserCount: group.userId
                    ? group.userId.split(",").filter(id => id.trim() !== "").length
                    : 0
            }));
            setAllusergroupList(withUserCounts)
        } catch (error) {
            message.error(error)
        }
    }
    const Action = (
        <div className='Flex_div'>
            <div className='Flex_divs' role="button" style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { setPermission('Read') } }} onClick={() => { setPermission('Read'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>{permission === "Read" && <FeatherIcon icon="check" size={20} className="Svg" />}</div>
                <div className='text_icon'><FeatherIcon icon="eye" size={20} className="text_iconspaces1" /><span className='text_iconspaces'>Can view</span></div>
            </div>
            <div className='Flex_divs' role="button" style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { setPermission('Read,Update') } }} onClick={() => { setPermission('Read,Update'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>{permission === "Read,Update" && <FeatherIcon icon="check" size={20} className="Svg" />}</div>
                <div className='text_icon'><FeatherIcon icon="edit" size={20} className="text_iconspaces1" /><span className='text_iconspaces'>Can view and update</span></div>
            </div>
            <div className='Flex_divs' role="button" style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { setPermission('Read,Update,Delete') } }} onClick={() => { setPermission('Read,Update,Delete'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>{permission === "Read,Update,Delete" && <FeatherIcon icon="check" size={20} className="Svg" />}</div>
                <div className='text_icon'><FeatherIcon icon="file-minus" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'>Can view, update and delete</span></div>
            </div>
            {/* <div className='Flex_divs' role="button" style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { setPermission('Read,Update,Delete,Sharing') } }} onClick={() => { setPermission('Read,Update,Delete,Sharing'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>{permission === "Read,Update,Delete,Sharing" && <FeatherIcon icon="check" size={20} className="Svg" />}</div>
                <div className='text_icon'><FeatherIcon icon="share-2" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'> Can view, update, delete and share</span></div>
            </div> */}
            <div className='Flex_divs' role="button" style={{ cursor: 'pointer' }} tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { setPermission('Revoke shared record') } }} onClick={() => { setPermission('Revoke shared record'); handleOpenChange(false) }}>
                <div className='text_icon' style={{ width: "20px" }}>{permission === "Revoke shared record" && <FeatherIcon icon="check" size={20} className="Svg" />}</div>
                <div className='text_icon'><FeatherIcon icon="user-x" size={20} className="text_iconspaces1" /> <span className='text_iconspaces'> Revoke shared record</span></div>
            </div>
        </div>
    )
    const extractAllUserIds = (mixedArray) => {
        return mixedArray
            .map(({ item }) => {
                const mapType = {
                    user: { id: item.userId, type: "User" },
                    group: { id: item.userGroupId, type: "UserGroup" }
                };
                const config = mapType[item.Ctype];
                return config
                    ? { shareWithId: config.id, shareWithType: config.type }
                    : null;
            })
            .filter(Boolean);
        // const allUserIds = new Set();
        // const visitedGroups = new Set();
        // const collectGroupUsers = (groupId) => {
        //     if (visitedGroups.has(groupId)) return;
        //     visitedGroups.add(groupId);

        //     const group = allusergroupList.find(g => g.userGroupId === groupId);
        //     if (!group) return;
        //     if (group.userId) {
        //         group.userId.split(',')
        //             .map(id => parseInt(id.trim(), 10))
        //             .forEach(id => allUserIds.add(id));
        //     }
        //     if (group.childUserGroupId) {
        //         group.childUserGroupId.split(',')
        //             .map(id => parseInt(id.trim(), 10))
        //             .forEach(childId => collectGroupUsers(childId));
        //     }
        // };
        // mixedArray.forEach(({ item }) => {
        //     if (item.Ctype === 'user') {
        //         if (item.userId) {
        //             allUserIds.add(item.userId);
        //         }
        //     } else if (item.Ctype === 'group') {
        //         if (item.userId) {
        //             item.userId.split(',').map(id => parseInt(id.trim(), 10)).forEach(id => allUserIds.add(id));
        //         }
        //         collectGroupUsers(item.Cvalue);
        //     }
        // });
        // return Array.from(allUserIds).join(',');
    };
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (permission !== "Revoke shared record") {
            try {
                if (pageType === "Create") {
                    const result = await extractAllUserIds(sendTo);
                    // let cleanedString = result
                    //     .split(",")
                    //     .map(id => parseInt(id.trim(), 10))
                    //     .filter(Boolean);
                    // cleanedString = cleanedString.filter(id => id !== profile.userId);
                    const cleanedResult = result.filter(item => {
                        if (item.shareWithType === "User") {
                            return Number(item.shareWithId) !== Number(profile.userId);
                        }
                        return true;
                    });
                    // remove already shared users
                    // const alreadyShared = exportData.map(item => item.shareWithId);
                    // cleanedString = cleanedString.filter(id => !alreadyShared.includes(id));
                    // const finalString = cleanedString.join(",");
                    const formData =
                    {
                        shareWith: cleanedResult,
                        shareEntity: sharingType,
                        sharePermission: access,
                        shareEntityIds: sharingIds.join(',')
                    }
                    const response = await createSharing(formData)
                    if (response.status === 201) {
                        message.success("Record shared successfully with selected users")
                        setSharePopup(false);
                        if (PageTypes === "Multiple") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                }
                if (pageType === "Update") {
                    const payload = {
                        shareWith: accessData.shareWith,
                        shareWithType: accessData.shareWithType,
                        shareEntity: accessData.shareEntity,
                        sharePermission: permission,
                        shareEntityIds: accessData.shareEntityIds
                    }
                    const response = await updateSharing(accessData.sharingId, payload)
                    if (response.status === 200) {
                        GetSharedDetails()
                        message.success("Shared access for selected user updated successful")
                        setPageType("UpdateList");
                        if (PageTypes === "Multiple") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                    }
                    if (accessData?.sharePermission === "Read,Update,Delete,Sharing") {
                        const data = await getAllSharedReportUserPermission(accessData.shareWith, sharingType, sharingIds.join(','))
                        delteAllsharing(data)
                        if (PageTypes === "Multiple") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            } catch (error) {
                message.error(error)
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
        else {
            loadingRef.current = false;
            setDelteClick(false)
            setShareUser(accessData.shareWith)
            setConfirmPopup(true)
            setDeleteId(accessData.sharingId)
        }
    }
    useEffect(() => {
        UserDetailsApi()
        GetUsergroupList()
        if (PageTypes === "Single") {
            GetSharedDetails()
        }
    }, [])
    const combineUsersAndGroups = (users, userGroups) => {
        const userList = users.map(user => ({
            ...user,
            Ctype: 'user',
            Cvalue: user.userId,
        }));

        const groupList = userGroups.map(group => ({
            ...group,
            Ctype: 'group',
            Cvalue: group.userGroupId,
        }));

        return [...userList, ...groupList];
    };
    const dataSource = combineUsersAndGroups(users, allusergroupList);
    const Pagechange = (value) => {
        setPageType(value)
        setExportData(FilterData)
    }
    return (
        <>
            <Modal
                title={pageType === "Create" ? "Share Record" : pageType === "UpdateList" ?
                    <div className='text_icon'>
                        <FeatherIcon icon="arrow-left"
                            className="text_iconspace"
                            style={{ cursor: "pointer" }}
                            onClick={() => Pagechange("Create")}
                        />
                        Manage Access</div> :
                    <div className='text_icon'>
                        <FeatherIcon icon="arrow-left"
                            className="text_iconspace"
                            style={{ cursor: "pointer" }}
                            onClick={() => Pagechange("UpdateList")}
                        />
                        Manage Access</div>
                }
                open={sharePopup}
                width={700}
                closable={!deleteClick}
                onCancel={() => deleteClick ? undefined : handleClose()}
                maskClosable={false}
                footer={pageType !== "UpdateList" ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        <Button htmlType="submit" className="gray-button" size="small" onClick={handleClose} disabled={deleteClick}>
                            <FeatherIcon icon="x" /> Cancel
                        </Button>
                        <Button htmlType="submit" onClick={onSubmit} size="small" className='button_colors' loading={deleteClick} disabled={((pageType === "Update" && permission === accessData?.sharePermission) || (pageType === "Create" && sendTo?.length === 0)) || deleteClick}
                        // disabled={previousPermission === "Read,Update,Delete,Sharing"}
                        >
                            {!deleteClick && <ShareIcon />}{pageType === "Update" ? "Apply" : "Share"}
                        </Button>
                    </div>
                ]
                    : false}
            >
                <AddUser>
                    <div className="user-info-form">
                        <BasicFormWrapper>
                            <Form style={{ width: '100%' }} form={form} name="Assignto">
                                <Row gutter={30} style={{ padding: "0px 20px" }}>
                                    {pageType === "Create" ? <>
                                        <Col span={24}>
                                            <AutoCompletes dataSource={dataSource} setAccess={setAccess} access={access} setSendTo={setSendTo} allDetails={FilterData} />
                                        </Col>
                                        {(PageTypes === "Single" && FilterData.length > 0) &&
                                            <Col style={{ margin: "15px 0px 0px 0px", padding: 0 }} span={24}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        cursor: "pointer",
                                                        flexWrap: "wrap"
                                                    }}
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                            setPageType('UpdateList')
                                                        }
                                                    }}
                                                    onClick={() => setPageType('UpdateList')}
                                                >
                                                    {FilterData.slice(0, maxVisibleImages).map((item, index) => (
                                                        <div
                                                            key={index}
                                                            title={item.shareWithType === "User" ? `${item.shareWithFirstName} ${item.shareWithLastName}` : item.shareWithUserGroup}
                                                            style={{
                                                                marginLeft: index === 0 ? "0" : "-10px", // overlap effect
                                                                zIndex: index + 1, // keep correct stacking
                                                            }}
                                                        >
                                                            {item.profilePic ? (
                                                                <img
                                                                    src={item.profilePic}
                                                                    alt="User Avatar"
                                                                    style={{
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        borderRadius: "50%",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span
                                                                    className={`image_icon OverLap_images ${item.shareWithType === "User" ? "UserIcon" : "GroupIcon"}`}
                                                                >
                                                                    {item.shareWithType === "User" ? item.shareWithFirstName.slice(0, 1).toUpperCase() : item.shareWithUserGroup.slice(0, 1).toUpperCase()}
                                                                </span>
                                                            )}
                                                        </div>
                                                    ))}

                                                    {FilterData.length > maxVisibleImages && (
                                                        <span
                                                            style={{
                                                                marginLeft: "8px",
                                                                color: "#1f7cf9",
                                                            }}
                                                        >
                                                            +{FilterData.length - maxVisibleImages} more
                                                        </span>
                                                    )}
                                                </div>
                                            </Col>
                                        }
                                    </>
                                        :
                                        pageType === "UpdateList" ?
                                            <Col span={24}>
                                                <div style={{ borderBottom: "1px solid #000", marginBottom: 30 }}>
                                                    <TopToolBoxClone3>
                                                        <AutoComplete onSearch={handleSearch} dataSource={exportData} placeholder="Search Displayed names" width="100%" patterns /></TopToolBoxClone3>
                                                </div>
                                                <AtbdTopDropdwon className="atbd-top-dropdwon" style={{ width: "100%", height: "250px" }}>
                                                    <Scrollbars style={{ height: 250 }}                                                >
                                                        <div className="atbd-top-dropdwon-menu">
                                                            {exportData.length ? exportData.map((item, index) => (
                                                                <div className='display_spaceBetween' style={{ cursor: item.shareBy === profile.userId ? 'pointer' : 'default' }} role="button" tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { setPageType('Update') } }} onClick={item.shareBy === profile.userId ? () => { setPageType('Update'); AccessDetails(item.sharingId) } : undefined}>
                                                                    <div className='d-flex align-items-start' key={index} style={{ margin: "0px 0px 0px 10px" }}>
                                                                        <div className='diplay-center'>{item.profilePic !== null && item.profilePic !== undefined && item.profilePic !== "" ? <img style={{ width: '30px', height: '30px', marginRight: '5px', borderRadius: 15 }} src={item.profilePic} alt="User Avatar" /> : <span className={`image_icon OverLap_images ${item.shareWithType === "User" ? "UserIcon" : "GroupIcon"}`} style={{ marginRight: '5px', borderRadius: 15 }}>{item.shareWithType === "User" ? item.shareWithFirstName.slice(0, 1).toUpperCase() : item.shareWithUserGroup.slice(0, 1).toUpperCase()}</span>}</div>
                                                                        <div><p style={{ fontWeight: '600', margin: 0 }}>{item.shareWithType === "User" ? `${item.shareWithFirstName} ${item.shareWithLastName}` : item.shareWithUserGroup}</p><p style={{ margin: 0 }}>{item.shareWithType === "User" ? item.email : item.groupUserCount}</p></div>
                                                                    </div>
                                                                    <div style={{ margin: "0px 20px 0px 0px" }} className='List_tag text_icon'>
                                                                        {item.sharePermission === "Read" && <FeatherIcon icon="eye" size={20} className="text_iconspace" />}
                                                                        {item.sharePermission === "Read,Update" && <FeatherIcon icon="edit" size={20} className="text_iconspace" />}
                                                                        {item.sharePermission === "Read,Update,Delete" && <FeatherIcon icon="file-minus" size={20} className="text_iconspace" />}
                                                                        {/* {item.sharePermission === "Read,Update,Delete,Sharing" && <FeatherIcon icon="share-2" size={20} className="text_iconspace" />} */}
                                                                    </div>
                                                                </div>
                                                            )) : ""}
                                                        </div>
                                                    </Scrollbars>
                                                </AtbdTopDropdwon>
                                            </Col>
                                            :
                                            <Col span={24}>
                                                {accessData &&
                                                    <>
                                                        <div style={{ fontWeight: 600, }}>Access Summary </div>
                                                        {/* <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', marginLeft: 10 }} title="Once you grant all permissions, especially share access, it cannot be reverted." /> */}
                                                        <div style={{ borderBottom: "1px solid #000" }}>
                                                            <div className='d-flex align-items-start' style={{ margin: "25px 0px" }}>
                                                                <div className='diplay-center'>
                                                                    {accessData.profilePic !== null && accessData.profilePic !== undefined && accessData.profilePic !== "" ?
                                                                        <img style={{ width: '30px', height: '30px', marginRight: '5px', borderRadius: 20 }}
                                                                            src={accessData.profilePic}
                                                                            alt="User Avatar"
                                                                        />
                                                                        :
                                                                        <span className="image_icon OverLap_images UserIcon" style={{ marginRight: '5px', borderRadius: 20 }}>
                                                                            {accessData.shareWithType === "User" ? accessData.shareWithFirstName.slice(0, 1).toUpperCase() : accessData.shareWithUserGroup.slice(0, 1).toUpperCase()}
                                                                        </span>
                                                                    }
                                                                </div>
                                                                <div className="diplay-center" style={{ fontSize: 20, fontWeight: 400 }} >
                                                                    {accessData.shareWithType === "User" ? `${accessData.shareWithFirstName} ${accessData.shareWithLastName}` : accessData.shareWithUserGroup}
                                                                </div>
                                                                <div style={{ fontWeight: 700, margin: "0px 10px", fontSize: 15 }} className='text_icon'>
                                                                    ({accessData.sharePermission})
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{ fontWeight: 600, margin: "25px 0px" }}>Ways this person has access</div>
                                                        <div className='text_icon' style={{ margin: "15px 0px", }}>
                                                            <FeatherIcon icon="disc" className="text_iconspace" size={15} /> Specific people with this data : <span style={{ cursor: "pointer", marginLeft: 10, fontWeight: 600 }}>
                                                                {/* {previousPermission === "Read,Update,Delete,Sharing" ?
                                                                    <>
                                                                        {permission} < FeatherIcon icon="chevron-down" size={20} style={{ marginLeft: 5 }} />
                                                                    </> : */}
                                                                <Popover className='text_icon'
                                                                    placement="bottomRight"
                                                                    content={Action}
                                                                    trigger="click"
                                                                    open={open}
                                                                    onOpenChange={handleOpenChange}
                                                                >
                                                                    {permission}<FeatherIcon icon="chevron-down" size={20} style={{ marginLeft: 5 }} />
                                                                </Popover>
                                                                {/* } */}
                                                            </span>
                                                        </div>
                                                    </>
                                                }
                                            </Col>
                                    }
                                </Row>
                            </Form>
                        </BasicFormWrapper>
                    </div>
                </AddUser>
            </Modal >
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} page="Share" />}
        </>
    );
};

Popup.propTypes = {
    sharePopup: PropTypes.bool.isRequired,
    setSharePopup: PropTypes.func.isRequired,
    sharingType: PropTypes.string.isRequired,
    sharingIds: PropTypes.array.isRequired,
    PageTypes: PropTypes.string.isRequired,
    setStates: PropTypes.func.isRequired,
};

export default Popup;
